import React, { Fragment, useEffect, useContext, useState } from 'react';
import { Row, Col, Layout, Menu, Space, Button, Dropdown, Typography, Divider, Tabs } from 'antd';
import { AppContext } from './../../Contexts/AppContext';
import { LockOutlined, DownOutlined } from '@ant-design/icons';
import { SecondaryButton } from 'Client/components/Buttons/SecondaryButton';
import { useHistory, useLocation, Link } from 'react-router-dom';
import DropdownOverlayComponent from './DropDownOverlayComponent';
import MobileDrawer from './MobileDrawer';
import { MenuFoldOutlined } from '@ant-design/icons';
import { HeaderCss } from './Header.style';
import { getPublicSiteImageSrc } from 'Client/common/utils/AppUtils';
import { REGISTRATION_PATHS } from 'Client/common/constants/AppConstants';

const HeaderComponent = () => {
  const history = useHistory();
  const [showHomeSection, setShowHomeSection] = useState(true);
  const [state, setState] = useState({
    data: { agencyManagementApi: null, commercialManagementApi: null },
    error: null,
    status: 'pending',
  });
  const [activeMenu, setActiveMenu] = useState('home');
  const [drpVisible, setDrpVisible] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedTab, setSelectedTab] = useState('home');
  const { wraSlotList } = useContext(AppContext);
  let location = useLocation();

  // Check if the current path contains any of the paths in REGISTRATION_PATHS
  const shouldHideButtons = REGISTRATION_PATHS.some(path => location.pathname.includes(path));


  useEffect(() => {
    getActiveMenuLabelName();
    populateLandingPageContents();
    const isRegistrationPathFound = location?.pathname?.split('/')?.includes('register');
    isRegistrationPathFound ? setShowHomeSection(false) : setShowHomeSection(true);
  }, [location]);

  useEffect(() => {
    if (drpVisible) {
      setActiveMenu('api-service');
    }
  }, [drpVisible])

  const getActiveMenuLabelName = () => {
    const activeMenu = history?.location?.pathname?.split('/');
    if (activeMenu?.includes('api-service')) {
      setActiveMenu('api-service');
    } else if (activeMenu?.includes('Partners')) {
      setActiveMenu('partners');
    } else if (activeMenu?.includes('apiDetails')) {
      setActiveMenu('');
    } else {
      setActiveMenu('home');
    }
  };

  const populateLandingPageContents = () => {
    const apiAssocList = wraSlotList?.find(data => data?.name === 'api-cards-marketing-list')?.ListAssoc || [];
    const agencyManagementApi = apiAssocList?.find(data => data?.name === 'partner_agency_mgmt_apis');
    const commercialManagementApi = apiAssocList?.find(data => data?.name === 'partner_comm_grp_subm_n_mbr_mgmt_apis');
    setState({
      data: { agencyManagementApi, commercialManagementApi },
      status: 'success',
    });
  };

  const [activeItem, setActiveItem] = useState('agency');

  const handleAPIItemClick = item => {
    setActiveItem(item);
  };

  const handleDrpVisibleHandler = () => {
    setDrpVisible(!drpVisible);
  };

  const closeDropDownHandler = () => {
    setDrpVisible(false);
  };

  const onTabChange = (key) => {
    setSelectedTab(key);
    setActiveMenu(key);
    
    if (key === 'home') {
      history.push('/');
      setDrpVisible(false);
    } else if (key === 'api-services') {
      // Toggle dropdown if already selected, otherwise just open it
      if (selectedTab === 'api-services') {
        setDrpVisible(!drpVisible);
      } else {
        setDrpVisible(true);
      }
    } else if (key === 'partners') {
      history.push('/explore/Partners');
      setDrpVisible(false);
    }
  };

  // Handle click outside and ESC key to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdownElement = document.querySelector('.dropdown__overlay');
      const tabsElement = document.querySelector('.header_tabs');
      
      if (drpVisible && dropdownElement) {
        if (!dropdownElement.contains(event.target) && !tabsElement?.contains(event.target)) {
          setDrpVisible(false);
        }
      }
    };

    const handleFocusOut = (event) => {
      setTimeout(() => {
        const activeElement = document.activeElement;
        const dropdownElement = document.querySelector('.dropdown__overlay');
        const tabsElement = document.querySelector('.header_tabs');
        
        if (drpVisible && dropdownElement) {
          if (!dropdownElement.contains(activeElement) && !tabsElement?.contains(activeElement)) {
            setDrpVisible(false);
          }
        }
      }, 0);
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && drpVisible) {
        setDrpVisible(false);
      }
    };

    if (drpVisible) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('focusout', handleFocusOut);
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('focusout', handleFocusOut);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [drpVisible]);

  const navToOverviewPage = () => {
    closeDropDownHandler();
    setActiveMenu('api-service');
    history.push('/explore/api-service');
  };

  const closeDrawer = () => setDrawerVisible(false);

  const openDrawer = () => setDrawerVisible(!drawerVisible);
  
  const imageURL = '/public/api/landing/fetch/anthem-branding-expanded-image.png';
  return (
    <Fragment>
      <Layout.Header css={HeaderCss} className="header__container">
        {/* {showHomeSection ? ( */}
          <Row>
            <Col span={24}>
              <Row align="middle" justify={!shouldHideButtons ? "flex-start" : "left"} className="header__row">
                <Col sm={6} md={5} lg={6} xl={5}>
                  <Link to="/explore">
                    <img src={imageURL} className="img-logo" alt="Company Logo" />
                  </Link>
                </Col>
                {!shouldHideButtons && (
                  <Col xs={0} sm={0} md={9} lg={{span: !shouldHideButtons ? 10 : 8 , offset: !shouldHideButtons ? 0 : 2}} xl={{span: !shouldHideButtons ? 11 : 8 , offset: !shouldHideButtons ? 0 : 2}} className="col__menu_section">
                    <Row className="menu_row">
                      <Col>
                        <Tabs
                          activeKey={selectedTab}
                          onTabClick={onTabChange}
                          className="header_tabs"
                          tabBarStyle={{ margin: 0, border: 'none' }}
                          items={[
                            {
                              key: 'home',
                              label: <span className='landing_menu_item '>Home</span>
                            },
                            {
                              key: 'api-services',
                              label: (
                                <span 
                                  className='landing_menu_item' 
                                  onClick={handleDrpVisibleHandler}
                                  aria-expanded={drpVisible}
                                  aria-haspopup="true"
                                  role="button"
                                >
                                  API Services <DownOutlined aria-hidden="true" />
                                </span>
                              )
                            },
                            {
                              key: 'partners',
                              label: <span className='landing_menu_item'>Partners</span>
                            }
                          ]}
                        />
                        {drpVisible && selectedTab === 'api-services' && (
                          <div 
                            className="dropdown__overlay"
                            style={{ position: 'fixed', top: '57px', left: 0, right: 0, zIndex: 1000 }}
                          >
                            <DropdownOverlayComponent
                              agencyApiData={state?.data?.agencyManagementApi}
                              commercialApiData={state?.data?.commercialManagementApi}
                              navToOverviewPage={navToOverviewPage}
                              closeDropDownHandler={closeDropDownHandler}
                              activeItem={activeItem}
                              onItemClick={handleAPIItemClick}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Col>)
                }
                { !shouldHideButtons && 
                  <Col xs={0} sm={0} md={5} lg={5} xl={5} className="header-btn-container">
                    <Space>
                      <Button
                      icon={ <LockOutlined aria-hidden="true" />}
                        className="header__login_btn header_btn"
                        onClick={() => window.location.assign('/login/')}
                      >
                        Log In
                      </Button>

                      <SecondaryButton
                        className="header__register-btn header_btn"
                        onClick={() => history.push('/register')}
                      >
                        Get Started
                      </SecondaryButton>
                    </Space>
                  </Col>
                }
                {
                  showHomeSection && (<Col xs={2} sm={8} md={5} lg={0} xl={0} className="align-right menu_icon_container">
                    <Space>
                    <Button 
                      className="hamburger__menu" 
                      onClick={openDrawer} 
                      type="link"
                      aria-label="Open navigation menu"
                      aria-expanded={drawerVisible}
                      icon={<img src={getPublicSiteImageSrc('hamburger.svg')} alt="hamburger" aria-hidden="true" />} 
                    />
                    </Space>
                    <MobileDrawer
                      agencyApiData={state?.data?.agencyManagementApi}
                      commercialApiData={state?.data?.commercialManagementApi}
                      closeDrawer={closeDrawer}
                      visible={drawerVisible}
                    />
                  </Col>)
                }
              </Row>
            </Col>
          </Row>
      </Layout.Header>
    </Fragment>
  );
};

export default HeaderComponent;
